var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "d-flex justify-content-start",
      staticStyle: { "margin-bottom": "5px" },
    },
    [
      _c("div", { staticClass: "p-05" }, [
        _vm.user_data !== null && _vm.supplier_data.length === 0
          ? _c("div", [
              _c("img", {
                staticClass: "round",
                attrs: {
                  src:
                    _vm.user_data !== null
                      ? _vm.user_data.avatar.url
                      : "/images/avatar.png",
                  alt: "avatar",
                  height: "30",
                  width: "30",
                },
              }),
            ])
          : _vm.supplier_data.length > 0
          ? _c("div", [
              _c("img", {
                staticClass: "round",
                attrs: {
                  src:
                    _vm.supplier_data[0].supplier_avatar !== null
                      ? _vm.supplier_data[0].supplier_avatar.url
                      : "/images/avatar.png",
                  alt: "avatar",
                  height: "30",
                  width: "30",
                },
              }),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "p-0 pt-05 justify-content-start" }, [
        _c("div", { staticClass: "user-name text-bold-600 text-dark" }, [
          _vm.supplier_data.length === 0
            ? _c(
                "div",
                { staticClass: "dropdown dropdown-user nav-item" },
                [
                  _c("a", {
                    staticClass: "dropdown-toggle dropdown-user-link",
                    attrs: {
                      href: _vm.postOwnerLink,
                      "data-toggle": "dropdown",
                    },
                    domProps: { textContent: _vm._s(_vm.postOwnerName) },
                    on: {
                      click: function ($event) {
                        _vm.show_profile = true
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "dropdown-menu dropdown-menu-center" },
                    [
                      _vm.show_profile
                        ? _c(
                            "div",
                            [
                              _c("profile", {
                                attrs: { owner: _vm.user_data },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.user_data.badges, function (badge) {
                    return _c("span", [
                      _c("img", {
                        staticStyle: { "margin-top": "-3px", height: "15px" },
                        attrs: {
                          src: badge.image,
                          "data-toggle": "tooltip",
                          "data-placement": "bottom",
                          title: badge.name,
                        },
                      }),
                    ])
                  }),
                  _vm._v(" "),
                  _vm.user_data.user_badge_id !== null
                    ? _c("span", [
                        _c("img", {
                          staticStyle: { "margin-top": "-3px", height: "15px" },
                          attrs: {
                            src: _vm.user_data.user_badge_image.url,
                            "data-toggle": "tooltip",
                            "data-placement": "bottom",
                            title: _vm.user_data.user_badge_name,
                          },
                        }),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.shared === true
                    ? _c("span", { staticClass: "text-bold-400" }, [
                        _vm._v(
                          _vm._s(_vm.__("globals.shared")) +
                            " " +
                            _vm._s(
                              _vm.type === "event"
                                ? "an " + _vm.type
                                : "a " + _vm.type
                            )
                        ),
                      ])
                    : _vm._e(),
                ],
                2
              )
            : _c("div", { staticClass: "nav-item" }, [
                _c("a", {
                  staticClass: "text-dark",
                  attrs: { href: _vm.postOwnerLink },
                  domProps: { textContent: _vm._s(_vm.postOwnerName) },
                }),
              ]),
        ]),
        _vm._v(" "),
        _vm.supplier_data.length > 0
          ? _c("div", { staticStyle: { "margin-top": "-5px" } }, [
              _c("span", {
                staticClass: "font-small-2 text-primary",
                domProps: {
                  textContent: _vm._s("@" + _vm.supplier_data[0].slug),
                },
              }),
            ])
          : _c(
              "div",
              {
                staticClass: "mr-2",
                staticStyle: { "margin-top": "-3px", "line-height": "1" },
              },
              [
                _c("span", {
                  staticClass: "font-small-2 text-light",
                  domProps: { textContent: _vm._s(_vm.user_data.position) },
                }),
                _vm._v(" "),
                _c("span", { staticClass: "font-small-2 text-light" }, [
                  _vm._v(" " + _vm._s(_vm.__("globals.at")) + " "),
                ]),
                _vm._v(" "),
                _c("span", {
                  staticClass: "font-small-2 text-light",
                  domProps: { textContent: _vm._s(_vm.user_data.organisation) },
                }),
              ]
            ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }